/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, before: NonNullable<unknown>, after: NonNullable<unknown> }} Plan_Edit_Volume_LineInputs */

const en_us2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} sets/week`)
};

const pt_br2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} séries/semana`)
};

const es_419_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} series/semana`)
};

const pt_pt2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} séries/semana`)
};

const fr_fr2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} : ${i?.before} → ${i?.after} séries/semaine`)
};

const de_de2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} Sätze/Woche`)
};

const it_it2_plan_edit_volume_line = /** @type {(inputs: Plan_Edit_Volume_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.before} → ${i?.after} serie/settimana`)
};

/**
* | output |
* | --- |
* | "{muscle}: {before} → {after} sets/week" |
*
* @param {Plan_Edit_Volume_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_volume_line = /** @type {((inputs: Plan_Edit_Volume_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Volume_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_volume_line(inputs)
	if (locale === "es-419") return es_419_plan_edit_volume_line(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_volume_line(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_volume_line(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_volume_line(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_volume_line(inputs)
	return en_us2_plan_edit_volume_line(inputs)
});
export { plan_edit_volume_line as "plan-edit.volume_line" }